import PATH from "constants/path";
import Menu from "./Menu";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isAuthenticated,
  formatNumber,
  getPathSerive,
  returnCommom,
} from "utils/common";
import {
  ButtonLoginNavbarPC,
  ButtonLoginNavbar,
  ButtonRegisterNavbarPC,
  ButtonRegisterNavbar,
  ButtonMenu,
} from "assets/svg";
import { LIST_LOGO, LIST_MENU } from "./constants";
import { cw_logo } from "assets/img";
import { logout } from "features/User/userSlice";

function Navbars() {
  const dispatch = useDispatch();

  const [openMenu, setOpenMenu] = useState("");

  const { userDisplay: user, isInLine } = useSelector((state) => state.user);
  const { site_setting, site_setting1, site_setting2 } = useSelector((state) => state.navbar);

  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <header className="clap sticky-top">
      {
        site_setting?.display_flg == 1 &&
        <div className="bg-white">
          <div className="container-fluid" dangerouslySetInnerHTML={{ __html: site_setting.body }}></div>
        </div>
      }
      <div className="bg-navbar-logo">
        {/* NAVBAR FOR SERVICE */}
        <nav className="navbar-logo navbar container-fluid">
          <a className="navbar-brand" href={PATH.COMMON}>
            アーキテクト会員サイト
          </a>
          <ul className="navbar-nav mx-auto">
            {LIST_LOGO.map((item, index) => (
              <li key={index} className="nav-item">
                <a href={item.link + getPathSerive()}>
                  <img
                    className="d-none d-md-block"
                    src={item.img}
                    alt={item.alt}
                  ></img>
                  <img
                    className="d-block d-md-none"
                    src={item.img_mobile}
                    alt={item.alt}
                  ></img>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {
        site_setting1?.display_flg == 1 &&
        <div className="bg-brown">
          <div className="container-fluid" dangerouslySetInnerHTML={{ __html: site_setting1.body }}></div>
        </div>
      }

      <div className="bg-navbar-menu">
        <nav className="navbar-menu navbar container-fluid">
          <a href="/" className="navbar-brand">
            <img src={cw_logo} className="logo-image" alt="am_logo"></img>
          </a>
          <ul className="navbar-nav align-items-center">
            {LIST_MENU.map((item, index) => (
              <li key={index} className="nav-item">
                <a className="nav-link" href={item.path}>
                  {item.name}
                </a>
              </li>
            ))}

            {!isAuthenticated() ? (
              <>
                <li className="nav-item">
                  <a onClick={() => returnCommom()} className="cursor-pointer">
                    <ButtonLoginNavbarPC />
                  </a>
                  <a
                    onClick={() =>
                      (window.location = PATH.COMMON + PATH.SIGNUP)
                    }
                    className="cursor-pointer ms-1"
                  >
                    <ButtonRegisterNavbarPC />
                  </a>
                </li>

                <li className="btn-group-menu">
                  <a className="cursor-pointer" onClick={() => returnCommom()}>
                    <ButtonLoginNavbar />
                  </a>
                  <a
                    onClick={() =>
                      (window.location = PATH.COMMON + PATH.SIGNUP)
                    }
                    className="cursor-pointer ms-2"
                  >
                    <ButtonRegisterNavbar />
                  </a>

                  <div
                    className="cursor-pointer"
                    onClick={() => setOpenMenu("active")}
                  >
                    <ButtonMenu />
                  </div>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <div
                    className="btn-navbar btn-border rounded-3 cursor-pointer"
                    onClick={() => handleLogout()}
                  >
                    ログアウト
                  </div>
                </li>
                <li className="btn-group-menu">
                  <a href={PATH.SETTING} className="btn-navbar btn-border">
                    {isInLine ? <span className="fs-16 align-bottom">****</span> : user && user?.name}
                    <span className="ms-02 fs-9 lh-21">さん</span>
                  </a>

                  <a
                    href={PATH.MY_POINT}
                    className="btn-navbar lh-16 fs-15 fw-600 btn-border mx-1"
                  >
                    {isInLine ? <span className="fs-16 lh-8 align-bottom">****</span> : formatNumber(user?.point)}
                    <span className="d-block">CLAP&WALKポイント</span>
                  </a>

                  <div
                    className="cursor-pointer"
                    onClick={() => setOpenMenu("active")}
                  >
                    <ButtonMenu />
                  </div>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>

      {
        site_setting2?.display_flg == 1 &&
        <div className="bg-brown">
          <div className="container-fluid" dangerouslySetInnerHTML={{ __html: site_setting2.body }}></div>
        </div>
      }

      <Menu
        user={user}
        isInLine={isInLine}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
        handleLogout={handleLogout}
        handleLogin={returnCommom}
      />
    </header>
  );
}

export default Navbars;
